<form [formGroup]="form" autocomplete="off">
    <h2>Certificate Details</h2>
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <fieldset>
        <div class="row">
            <div class="col-sm-5 mvd_form-group">
                <label class="required" title="* Required">Medical Certificate Decision</label>
                <select formControlName="decisionTypeId" class="mvd_form-control">
                    <option [ngValue]="null"></option>
                    <option *ngFor="let t of mecDecisionTypes" [ngValue]="t.id">{{ t.displayValue }}</option>
                </select>
                <control-validation-messages control="decisionTypeId"></control-validation-messages>
            </div>
            <div class="col-sm-7 mvd_form-group">
                <label>Medical Certificate Restrictions</label>
                <p-multiSelect [options]="filteredRestrictionTypes"
                               (onChange)="restrictionsChanged($event.value)"
                               formControlName="restrictionIds"
                               defaultLabel="None">
                </p-multiSelect>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-5 mvd_form-group">
                <label class="mvd_label--inline"><input formControlName="isLongForm" type="checkbox" /> Is Medical Exam Certificate Long Form</label>
            </div>
            <div class="col-sm-7 mvd_form-group">
                <button type="button" class="btn--default" (click)="createAdditionalRequirements()" *ngIf="!isReadOnly">CDL-MRP Additional Requirements</button>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-5 mvd_form-group" *ngIf="true == showWaivers()">
                <label>Waiver Type</label>
                <p-multiSelect [options]="mecWaiverTypes"
                               formControlName="waiverIds"
                               defaultLabel="None">
                </p-multiSelect>
            </div>
            <div class="col-sm-5 mvd_form-group" *ngIf="true == showExemptions()">
                <label>Exemption Type</label>
                <p-multiSelect [options]="mecExemptionTypes"
                               formControlName="exemptionIds"
                               defaultLabel="None">
                </p-multiSelect>
            </div>
        </div>
        <select-conditions [customerNumberId]="customerNumberId" [isReadOnly]="isReadOnly"></select-conditions>
    </fieldset>
    <h2>Medical Examiner</h2>
    <fieldset>
        <div class="row">
            <div class="col-sm-4 col-md-2 mvd_form-group">
                <label class="required" title="* Required">First Name</label>
                <input type="text" class="mvd_form-control" data-id="examinerFirstName" formControlName="examinerFirstName" />
                <control-validation-messages control="examinerFirstName"></control-validation-messages>
                <div class="mvd_alert__validation" *ngIf="form.hasError('invalidExaminerName', 'examinerFirstName')">
                    <div class="mvd_alert__rule">Name can only contain letters, numbers, apostrophes, and hyphens</div>
                </div>
            </div>
            <div class="col-sm-4 col-md-2 mvd_form-group">
                <label>Middle Name</label>
                <input type="text" class="mvd_form-control" data-id="examinerMiddleName" formControlName="examinerMiddleName" />
                <div class="mvd_alert__validation" *ngIf="form.hasError('invalidExaminerName', 'examinerMiddleName')">
                    <div class="mvd_alert__rule">Name can only contain letters, numbers, apostrophes, and hyphens</div>
                </div>
            </div>
            <div class="col-sm-4 col-md-2 mvd_form-group">
                <label class="required" title="* Required">Last Name</label>
                <input type="text" class="mvd_form-control" data-id="examinerLastName" formControlName="examinerLastName" />
                <control-validation-messages control="examinerLastName"></control-validation-messages>
                <div class="mvd_alert__validation" *ngIf="form.hasError('invalidExaminerName', 'examinerLastName')">
                    <div class="mvd_alert__rule">Name can only contain letters, numbers, apostrophes, and hyphens</div>
                </div>
            </div>
            <div class="col-sm-4 col-md-2 mvd_form-group">
                <label>Suffix</label>
                <select class="mvd_form-control" data-id="examinerSuffix" formControlName="examinerSuffix">
                    <option [ngValue]="null"></option>
                    <option *ngFor="let suffix of suffixTypes" [ngValue]="suffix.id">{{ suffix.displayValue }}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-lg-4 mvd_form-group">
                <label class="required" title="* Required">Medical Examiner License Number</label>
                <input formControlName="examinerLicenseNumber" type="text" class="mvd_form-control" maxlength="15">
                <control-validation-messages control="examinerLicenseNumber"></control-validation-messages>
                <div class="mvd_alert__validation" *ngIf="form.hasError('invalidLicenseNumber', 'examinerLicenseNumber')">
                    <div class="mvd_alert__rule">License Number can only contain letters and numbers</div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-4 mvd_form-group">
                <label class="required" title="* Required">Medical Examiner Specialty Code</label>
                <select formControlName="specialtyCodeTypeId" class="mvd_form-control">
                    <option [ngValue]="null"></option>
                    <option *ngFor="let t of mecSpecialtyCodeTypes" [ngValue]="t.id">{{ t.displayValue }}</option>
                </select>
                <control-validation-messages control="specialtyCodeTypeId"></control-validation-messages>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-lg-4 mvd_form-group">
                <label class="required" title="* Required">Medical Examiner Telephone Number</label>
                <p-inputMask formControlName="examinerPhoneNumber"
                             mask="(999) 999-9999"
                             [unmask]="true">
                </p-inputMask>
                <control-validation-messages control="examinerPhoneNumber"></control-validation-messages>
                <div class="mvd_alert__validation" *ngIf="form.hasError('repeatingDigits', 'examinerPhoneNumber')">
                    <div class="mvd_alert__rule">Characters must not be repeating</div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-4 mvd_form-group">
                <label class="required" title="* Required">Medical Examiner Registry Code</label>
                <input formControlName="examinerRegistryCode" type="text" class="mvd_form-control" maxlength="15">
                <control-validation-messages control="examinerRegistryCode"></control-validation-messages>
                <div class="mvd_alert__validation" *ngIf="form.hasError('invalidRegistryCode', 'examinerRegistryCode')">
                    <div class="mvd_alert__rule">Registry Code must be a 10 digit number</div>
                </div>
                <div class="mvd_alert__validation" *ngIf="form.hasError('repeatingDigits', 'examinerRegistryCode')">
                    <div class="mvd_alert__rule">Characters must not be repeating</div>
                </div>
            </div>
            <div class="col-sm-3 mvd_form-group">
                <label class="required" title="* Required">Issuing State</label>
                <select formControlName="issuingJurisdictionId" class="mvd_form-control">
                    <option [ngValue]="null"></option>
                    <option *ngFor="let j of jurisdictions" [ngValue]="j.id">{{ j.jurisdictionDisplayValue }}</option>
                </select>
                <control-validation-messages control="issuingJurisdictionId"></control-validation-messages>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-lg-3 mvd_form-group">
                <label [class.required]="!form.get('qualificationStatusDate')?.value"
                       [attr.title]="!form.get('qualificationStatusDate')?.value ? '* Required' : null">
                    Signature Date
                </label>
                <p-calendar placeholder="mm/dd/yyyy"
                            showButtonBar="true"
                            name="signatureDate"
                            [showIcon]="true"
                            dateFormat="mm/dd/yy"
                            formControlName="signatureDate">
                </p-calendar>
                <control-validation-messages control="signatureDate"></control-validation-messages>
                <div class="mvd_alert__validation" *ngIf="form.hasError('signatureDateTooLarge', 'signatureDate')">
                    <div class="mvd_alert__rule">Signature Date can not be in the future</div>
                </div>
            </div>
            <div class="col-sm-4 col-lg-3 mvd_form-group">
                <label>Expiration Date</label>
                <p-calendar placeholder="mm/dd/yyyy"
                            showButtonBar="true"
                            name="expirationDate"
                            [showIcon]="true"
                            dateFormat="mm/dd/yy"
                            formControlName="expirationDate">
                </p-calendar>
                <control-validation-messages control="expirationDate"></control-validation-messages>
                <div class="mvd_alert__validation" *ngIf="form.hasError('expirationDateTooSmall', 'expirationDate')">
                    <div class="mvd_alert__rule">Signature Date must be before the Expiration Date</div>
                </div>
                <div class="mvd_alert__validation" *ngIf="form.hasError('expirationDateTooLarge', 'expirationDate')">
                    <div class="mvd_alert__rule">MEC can not exceed 2 years</div>
                </div>
            </div>
        </div>
        <div class="row">
            <ng-container *ngIf="speRestrictionWasSelected">
                <div class="col-sm-6 col-lg-4 mvd_form-group">
                    <label>SPE Certificate Effective Date</label>
                    <p-calendar placeholder="mm/dd/yyyy"
                                showButtonBar="true"
                                name="speCertificateEffectiveDate"
                                [showIcon]="true"
                                dateFormat="mm/dd/yy"
                                formControlName="speCertificateEffectiveDate">
                    </p-calendar>
                </div>
                <div class="col-sm-6 col-lg-4 mvd_form-group">
                    <label>SPE Expiration Date</label>
                    <p-calendar placeholder="mm/dd/yyyy"
                                showButtonBar="true"
                                name="speCertificateEndDate"
                                [showIcon]="true"
                                dateFormat="mm/dd/yy"
                                formControlName="speCertificateEndDate">
                    </p-calendar>
                </div>
            </ng-container>
        </div>
        <ng-container *ngIf="!!hasExemptions() || !!hasWaivers() || !!isGrandfatheredSelected()">
            <div class="row" *ngIf="true == isGrandfatheredSelected()">
                <div class="col-sm-12 mvd_form-group">
                    <label class="mvd_label--inline"><input formControlName="isGrandfatherEligible" type="checkbox" /> Is Grandfather Eligible</label>
                </div>
            </div>
        </ng-container>
        <div class="row">
            <div class="col-8 col-sm-5 mvd_form-group">
                <label>Document</label>
                <div class="mvd_form-control">{{ documentFilename }}</div>
            </div>
            <div class="col-4 col-sm-5 mvd_form-group">
                <button type="button" class="icon--add btn--default" (click)="uploadDocument()" *ngIf="!isReadOnly">Add Document</button>
            </div>
        </div>
    </fieldset>
    <customer-mrp-restrictions [customerNumberId]="customerNumberId" [isReadOnly]="isReadOnly"></customer-mrp-restrictions>
    <h2>Exemptions and Waivers</h2>
    <table class="mvd_table--primeng">
        <thead>
            <tr>
                <th>Type</th>
                <th>Description</th>
                <th>Restriction Type</th>
                <th class="w--date-time required" title="* Required">Effective Date</th>
                <th class="w--date-time required" title="* Required">Expiration Date</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngIf="false == hasWaivers() && false == hasExemptions()">
                <tr><td [attr.colspan]="5">No Exemptions or Waivers</td></tr>
            </ng-container>
            <ng-container *ngIf="true == hasWaivers()">
                <tr *ngFor="let w of form.get('waiverDetails')['controls']" [formGroup]="w">
                    <td>Waiver</td>
                    <td>{{ w.get('displayValue').value }}</td>
                    <td>{{ w.get('restrictionTypeDisplayValue').value }}</td>
                    <td class="td__overflow">
                        <p-calendar placeholder="mm/dd/yyyy"
                                    name="effectiveDate"
                                    [showIcon]="true"
                                    dateFormat="mm/dd/yy"
                                    formControlName="effectiveDate">
                        </p-calendar>
                        <control-validation-messages control="effectiveDate"></control-validation-messages>
                        <div class="mvd_alert__validation" *ngIf="w.errors?.effectiveDateTooLarge && w.touched">
                            <div class="mvd_alert__rule">Effective Date can not be in the future</div>
                        </div>
                    </td>
                    <td class="td__overflow">
                        <p-calendar placeholder="mm/dd/yyyy"
                                    name="expirationDate"
                                    [showIcon]="true"
                                    dateFormat="mm/dd/yy"
                                    formControlName="expirationDate">
                        </p-calendar>
                        <control-validation-messages control="expirationDate"></control-validation-messages>
                        <div class="mvd_alert__validation" *ngIf="w.errors?.expirationDateTooSmall && w.touched">
                            <div class="mvd_alert__rule">Effective Date must be before the Expiration Date</div>
                        </div>
                    </td>
                </tr>
            </ng-container>
            <ng-container *ngIf="true == hasExemptions()">
                <tr *ngFor="let e of form.get('exemptionDetails')['controls']" [formGroup]="e">
                    <td>Exemption</td>
                    <td>{{ e.get('displayValue').value }}</td>
                    <td>{{ e.get('restrictionTypeDisplayValue').value }}</td>
                    <td class="td__overflow">
                        <p-calendar placeholder="mm/dd/yyyy"
                                    name="effectiveDate"
                                    [showIcon]="true"
                                    dateFormat="mm/dd/yy"
                                    formControlName="effectiveDate">
                        </p-calendar>
                        <control-validation-messages control="effectiveDate"></control-validation-messages>
                        <div class="mvd_alert__validation" *ngIf="e.errors?.effectiveDateTooLarge && e.touched">
                            <div class="mvd_alert__rule">Effective Date can not be in the future</div>
                        </div>
                    </td>
                    <td class="td__overflow">
                        <p-calendar placeholder="mm/dd/yyyy"
                                    name="expirationDate"
                                    [showIcon]="true"
                                    dateFormat="mm/dd/yy"
                                    formControlName="expirationDate">
                        </p-calendar>
                        <control-validation-messages control="expirationDate"></control-validation-messages>
                        <div class="mvd_alert__validation" *ngIf="e.errors?.expirationDateTooSmall && e.touched">
                            <div class="mvd_alert__rule">Effective Date must be before the Expiration Date</div>
                        </div>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</form>